<template>
  <section>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <!-- <el-button type="primary" @click="division_add()">新增</el-button> -->
    <el-form
     class="form_cls"
      :inline="true"
      v-if="buttonList != null && buttonList.length > 0"
      :model="filters"
      @submit.native.prevent
    >
      <el-form-item label="查询">
        <el-input v-model="filters.key" placeholder="请输入内容"></el-input>
      </el-form-item>
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button
          :type="
            item.Func &&
            (item.Func.toLowerCase().indexOf('handledel') != -1 ||
              item.Func.toLowerCase().indexOf('stop') != -1)
              ? 'danger'
              : 'primary'
          "
          v-if="!item.IsHide"
          @click="callFunc(item)"
          >{{ item.name }}</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <div class="table_top_div">
        <div>
    <el-table
    border
    :max-height="tableHeight"
      :data="users"
      :header-cell-style="{'text-align':'center','color':'#6170d7','backgroundColor':'#F5F7FA'}" :cell-style="{'text-align':'center'}"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="width: 100%"
    >
      <el-table-column type="index" width="80"></el-table-column>
      <el-table-column sortable
        prop="MsgContent"
        label="内容"
        width
      ></el-table-column>
      <!-- <el-table-column sortable prop="html" label="内容" width="" sortable></el-table-column> -->
      <el-table-column sortable
        prop="CreateTime"
        label="创建日期"
        width
      ></el-table-column>
      <el-table-column label="操作" width="150">
        <template scope="scope">
                <el-link type="primary" @click="handleEdit(scope.row)"><i class="el-icon-edit"></i>编辑&nbsp;|&nbsp;</el-link>
          <!-- <el-link type="primary" @click="handleEdit(scope.row.id)"
            >编辑</el-link
          >| -->
          
           <el-link type="primary" v-if="scope.row.IsDisable==false" @click="handleDisable(scope.row,true,'停用')"><i class="el-icon-edit"></i>停用&nbsp;|&nbsp;</el-link>
           <el-link type="primary" v-if="scope.row.IsDisable==true" @click="handleDisable(scope.row,false,'启用')"><i class="el-icon-edit"></i>启用&nbsp;|&nbsp;</el-link>
          <el-link type="danger" @click="handleDel(scope.row.ID)"><i class="el-icon-delete"></i>删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    </div>
    <!--工具条-->
    <div class="toolbar_div">
        <el-col :span="24" class="toolbar">
        <!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
         <el-pagination :background='true' layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="50" :total="total" style="float: right"></el-pagination>
        </el-col>
    </div>
        </div>
    <!-- 新增 -->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      width="80%"
    >
      <el-form
        ref="addForm"
        :model="addForm"
        :rules="editFormRules"
        label-width="150px"
        label-position="left"
      >
        <!-- <el-row>
          <el-col :span="22">
            <el-form-item label="通知标题" prop="type">
              <el-input v-model="addForm.MsgContent" placeholder="通知标题"></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="22">
            <el-form-item label="通知内容" required="true">
                 <el-input v-model="addForm.MsgContent"  type="textarea" :rows="5" placeholder="通知内容"></el-input>
              <!-- <quill-editor
                ref="text"
                v-model="addForm.Body"
                class="myQuillEditor"
                :options="editorOption"
              /> -->
              <!-- <el-input type="textarea" rows='5' v-model="addForm.html"></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!-- 修改 -->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      width="80%"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        label-width="150px"
        label-position="left"
        style="width: 100%"
      >
        <!-- <el-row>
          <el-col :span="22">
            <el-form-item label="通知标题" prop="type">
              <el-input v-model="editForm.Title" placeholder="通知标题"></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="22">
            <el-form-item label="通知内容" required="true">
                 <el-input v-model="editForm.MsgContent"   type="textarea" :rows="5" placeholder="通知内容"></el-input>
              <!-- <quill-editor
                ref="text"
                v-model="editForm.Body"
                class="myQuillEditor"
                :options="editorOption"
              /> -->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  MsgQueryPage,
  MsgUpdateMsg,
  MsgDeleteById,
  MsgDisableById,
  mail_template_Post,
  MsgAddMsg,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar, quillEditor },
  data() {
    return {
        tableHeight:0,
      buttonList: [],
      editorOption: {
        // editorOption里是放图片上传配置参数用的，例如：
        action: "/images/Upload/Pic", // 必填参数 图片上传地址
        methods: "post", // 必填参数 图片上传方式
        token: this.token, // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
        // name: 'upload_file',  // 必填参数 文件的参数名
        // size: 500,  // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
        // accept: 'multipart/form-data, image/png, image/gif, image/jpeg, image/bmp, image/x-icon,image/jpg'  // 可选 可上传的图片格式
      },
      token: "",
      addLoading: false,
      editFormRules: {
        html: [{ required: true, message: "请填写", trigger: "blur" }],
        type: [{ required: true, message: "请填写", trigger: "blur" }],
      },
      currentRow: null,
      filters: {
        key: "",
      },
      addForm: {
        id: 0,
        html: "",
        type: "",
        createtime: new Date(+new Date() + 8 * 3600 * 1000).toISOString(),
        is_deleted: 0,
        timestamp: new Date(+new Date() + 8 * 3600 * 1000).toISOString(),
      },
       editForm: {
        id: 0,
        html: "",
        type: "",
        createtime: new Date(+new Date() + 8 * 3600 * 1000).toISOString(),
        is_deleted: 0,
        timestamp: new Date(+new Date() + 8 * 3600 * 1000).toISOString(),
      },
      addFormVisible: false,
      editFormVisible: false,
      users: [],
      statusList: [
        { LinkUrl: "激活", value: true },
        { LinkUrl: "禁用", value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
    };
  },
  methods: {
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
    },
    // 显示修改界面
    handleEdit(e) {
        this.editFormVisible = true
    //   this.editForm = e
      this.editForm = JSON.parse(JSON.stringify(e)); 
    },
    editSubmit: function () {
    //   this.$refs.editForm.validate((valid) => {
    //     if (valid) {
        if(!this.editForm.MsgContent){
            this.$message({
                message: '请输入通知内容',
                type: "error",
              });
              return
        }
          MsgUpdateMsg(this.editForm).then((res) => {
            if (res.data.success) {
              this.editLoading = false;
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.getModules_search();
              this.editFormVisible = false;
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
              this.editFormVisible = false;
            }
          });
    //     } else {
    //     }
    //   });
    },
    //新增
    addSubmit: function () {
    //   this.$refs.addForm.validate((valid) => {
    //     if (valid) {
        if(!this.addForm.MsgContent){
            this.$message({
                message: '请输入通知内容',
                type: "error",
              });
              return
        }
        MsgAddMsg(this.addForm).then((res) => {
            if (res.data.success) {
              this.editLoading = false;
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.getModules_search();
              this.addFormVisible = false;
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
              this.addFormVisible = false;
            }
          });
    //     } else {
    //       console.log("error submit!!");
    //       return false;
    //     }
    //   });
    },
    // 删除
    handleDel(ids) {
      console.log(ids);
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: ids };
          MsgDeleteById(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getModules_search();
          });
        })
        .catch(() => {});
    },
    // 停用
    handleDisable(ids,IsDisable,title) {
      console.log(ids);
      this.$confirm("确认"+title+"该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
        ids.IsDisable=IsDisable   
          MsgDisableById(ids).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message:  title+"成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getModules_search();
          });
        })
        .catch(() => {});
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunc(item) {
      this[item.Func].apply(this, item);
    },
    // callFunction(item) {
    //   this.filters = {
    //     name: item.search,
    //   };
    //   this[item.Func].apply(this, item);
    // },
    //性别显示转换
    formatEnabled: function (row, column) {
      return row.Enabled ? "正常" : "未知";
    },
    formatCreateTime: function (row, column) {
      return !row.createtime || row.createtime == ""
        ? ""
        : util.formatDate.format(new Date(row.createtime), "yyyy-MM-dd hh:mm");
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getModules();
    },
    getModules_search() {
      this.page = 1;
      this.getModules();
    },
    //获取用户列表
    getModules() {
      let para = this.filters;
      para.page = this.page;
      console.log(para);
      // return
      //   let para = {
      //     page: this.page,
      //     key: this.filters.key
      //   };
      this.listLoading = true;
      MsgQueryPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        console.log(this.users)
        this.listLoading = false;
      });
    },
    //编辑
    // handleEdit: function (ids) {
    //     // console.log(id)
    //     // return
    //     this.$router.push({path:'/CustomerManagement/Channel_add',query: {id:ids,type:1}})
    // },
    selsChange: function (sels) {
      this.sels = sels;
    },
  },
  mounted() {
     this.$nextTick(()=>{
        	      this.tableHeight = window.innerHeight - 250;
		})
    this.getModules();
    let tokenStr = window.localStorage.Token;
    this.token = {
      Authorization: "Bearer " + tokenStr,
    };
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    console.log(this.buttonList);
  },
};
</script>

<style scoped>
</style>
